import { each } from 'lodash';
import { App, defineAsyncComponent } from 'vue';

// keep basic cpns no async
import UiAnimation from './Animation/index.vue';
import UiParallax from './Parallax/index.vue';
import UiHorizontal from './Horizontal/index.vue';
import UiButton from './Button/Themed.vue';
import UiPicture from './Picture/index.vue';

// simple bar css
import 'simplebar-vue/dist/simplebar.min.css';

const components = {
  'ui-animation':       UiAnimation,
  'ui-parallax':        UiParallax,
  'ui-horizontal':      UiHorizontal,
  'ui-button':          UiButton,
  'ui-picture':         UiPicture,
  'ui-accordions':      defineAsyncComponent(()=>import('./Accordions/Items.vue')),
  'ui-accordions-item': defineAsyncComponent(()=>import('./Accordions/Item.vue')),
  'ui-lightbox':        defineAsyncComponent(()=>import('./Lightbox/index.vue')),
  'ui-marquee':         defineAsyncComponent(()=>import('./Marquee/index.vue')),
  'ui-pagination':      defineAsyncComponent(()=>import('./Pagination/index.vue')),
  'ui-search':          defineAsyncComponent(()=>import('./Search/index.vue')),
  'ui-swiper':          defineAsyncComponent(()=>import('./Swiper/index.vue')),
  'ui-video':           defineAsyncComponent(()=>import('./Video/index.vue')),
  'ui-wysiwyg':         defineAsyncComponent(()=>import('./Wysiwyg/index.vue')),
  'ui-scroll':          defineAsyncComponent(()=>import('simplebar-vue')),
  /* OPTIONALS - check _optional folder */
  // 'ui-pdf':             defineAsyncComponent(()=>import('./PDF/index.vue')),
}

export const install = function(app:App):void{
  each(components, (component, name)=>{
    app.component(name, component)
  })
}

export default install

